export const InputIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      d='M62 134C62 130.686 64.6863 128 68 128H350C353.314 128 356 130.686 356 134V167C356 170.314 353.314 173 350 173H68C64.6863 173 62 170.314 62 167V134Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M68 124H350C355.523 124 360 128.477 360 134V167C360 172.523 355.523 177 350 177H68C62.4771 177 58 172.523 58 167V134C58 128.477 62.4772 124 68 124ZM68 128C64.6863 128 62 130.686 62 134V167C62 170.314 64.6863 173 68 173H350C353.314 173 356 170.314 356 167V134C356 130.686 353.314 128 350 128H68Z'
      fill='#38B2AC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M80 150.5C80 148.015 82.0147 146 84.5 146H205.5C207.985 146 210 148.015 210 150.5C210 152.985 207.985 155 205.5 155H84.5C82.0147 155 80 152.985 80 150.5Z'
      fill='#A0AEC0'
    />
    <path
      d='M287.211 161H286.404C286.181 161 286 160.795 286 160.543C286 160.291 286.181 160.087 286.404 160.087H287.212C287.88 160.087 288.423 159.472 288.423 158.717V142.283C288.423 141.528 287.88 140.913 287.212 140.913L286.404 140.913C286.181 140.913 286 140.709 286 140.457C286 140.204 286.181 140 286.404 140H287.212C288.325 140 289.231 141.024 289.231 142.283V158.717C289.231 159.975 288.324 161 287.211 161Z'
      fill='#4A5568'
    />
    <path
      d='M291.25 161H290.442C289.329 161 288.423 159.975 288.423 158.717V142.283C288.423 141.024 289.329 140 290.442 140H291.25C291.473 140 291.654 140.205 291.654 140.457C291.654 140.709 291.473 140.913 291.25 140.913H290.442C289.774 140.913 289.231 141.528 289.231 142.283V158.717C289.231 159.473 289.774 160.087 290.442 160.087H291.25C291.473 160.087 291.654 160.291 291.654 160.543C291.654 160.795 291.473 161 291.25 161Z'
      fill='#4A5568'
    />
    <path
      d='M290.442 150.956H287.211C286.988 150.956 286.807 150.752 286.807 150.5C286.807 150.248 286.988 150.043 287.211 150.043H290.442C290.665 150.043 290.846 150.248 290.846 150.5C290.846 150.752 290.665 150.956 290.442 150.956Z'
      fill='#4A5568'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M218 161C217.448 161 217 160.552 217 160L217 141C217 140.448 217.448 140 218 140C218.552 140 219 140.448 219 141L219 160C219 160.552 218.552 161 218 161Z'
      fill='#4A5568'
    />
  </svg>
)
